export const AssetTypeListValueObject = (data: string[]): { list: string[] } => {
  return Object.freeze({
    list: data,
  });
};
